<template>
  <v-menu
    v-if="asMenu"
    v-model="show"
    top
    offset-y
    right
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn text :outlined="menuButtonOutlined" small v-bind="attrs" v-on="on">
        {{ (menuTitle ? menuTitle + ": " : "") + title }}
      </v-btn>
    </template>

    <v-card width="650">
      <v-card-title>
        {{ $t("module.masterTimePicker.range") }}
      </v-card-title>
      <v-card-text>
        <time-range-picker v-model="range" @close="show = false" />
      </v-card-text>
    </v-card>
  </v-menu>

  <v-dialog v-model="show" width="650" v-else>
    <template v-slot:activator="{ on }">
      <v-btn x-small v-on="on">
        {{ title }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        {{ $t("module.masterTimePicker.range") }}
      </v-card-title>
      <v-card-text>
        <time-range-picker v-model="range" @close="show = false" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text small color="primary" @click="show = false">{{
          $t("common.close")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TimeRangePicker from "@/components/common/TimeRangePicker.vue";
import widgetMixin from "@/_helpers/widgetMixin";
export default {
  name: "ChartTimeRangeForm",

  mixins: [widgetMixin],

  components: {
    TimeRangePicker,
  },

  props: {
    value: {
      type: Object,
      default: undefined,
    },

    asMenu: {
      type: Boolean,
      default: false,
    },

    menuButtonOutlined: {
      type: Boolean,
      default: false,
    },

    menuTitle: {
      default: undefined,
    },
  },

  model: {
    prop: "value",
    event: "input",
  },

  emits: ["input"],

  data() {
    return {
      show: false,
    };
  },

  computed: {
    title() {
      if (this.range?.start === undefined || this.range?.end === undefined)
        return this.$t("module.masterTimePicker.range");

      let start = this.isRelativeTime(this.range?.start)
        ? this.range?.start
        : this.humanDate(this.range.start);
      let end = this.isRelativeTime(this.range?.end)
        ? this.range?.end
        : this.humanDate(this.range.end);

      return `${start} -> ${end}`;
    },

    range: {
      get() {
        return this.value;
      },

      set(val) {
        if (val?.start === undefined || val?.end === undefined) {
          this.$emit("input", undefined);
          return;
        }

        this.$emit("input", val);
      },
    },
  },
};
</script>
